import { render } from "./BlogSection.vue?vue&type=template&id=54e7cd2c&scoped=true"
import script from "./BlogSection.vue?vue&type=script&lang=js"
export * from "./BlogSection.vue?vue&type=script&lang=js"

import "./BlogSection.vue?vue&type=style&index=0&id=54e7cd2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e7cd2c"]])

export default __exports__